<template>
    <v-card>
        <v-form ref="permissionEditForm" :lazy-validation="true" v-model="formValid">
            <v-card-title>Permission Edit</v-card-title>

            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-radio-group v-model="$props.permission.perm_action">
                            <v-radio color="#c42111" label="Allow" value="ALLOW" />
                            <v-radio color="#c42111" label="Deny" value="DENY" />
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete autocomplete="off" label="Function" v-model="$props.permission.perm_function" color="#c42111" :items="permissionsList" :rules="[validation.required($props.permission.perm_function, 'Function')]" @change="functionChange" />
                    </v-col>

                    <v-col cols="12">
                        <v-text-field autocomplete="off" label="Resource" color="#c42111" v-model="$props.permission.perm_qualifier" :disabled="!resourceFunction && !alarmResourceFunction" />
                    </v-col>
                    
                    <template v-if="alarmResourceFunction">
                        <v-col cols="12" md="4">
                            <v-text-field label="Office" color="#c42111" v-model="alarmOfficeResource" disabled />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field label="Location" color="#c42111" v-model="alarmLocationResource" disabled />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field label="Description" color="#c42111" v-model="alarmDescriptionResource" disabled />
                        </v-col>
                    </template>
                </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-btn text @click="$store.commit('openWikiHelp', 'Administration/Permissions')">help</v-btn>
                <div class="flex-grow-1"></div>
                <v-btn text @click="$emit('cancel')">cancel</v-btn>
                <v-btn text @click="okClicked">ok</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
export default {
    name: 'PermissionEdit',
    props: ['permission', 'permissionsList'],
    components: {

    },
    data: () => ({
        formValid: true,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
        },
        functionsThatCanUseAlarmResources: [
            'alarm/*',
            'alarm/ack',
            'alarm/clear',
            'alarm/mark-service-affecting',
            'alarm/remark',
            'alarm/unack',
            'alarm/unclear',
            'alarm/unmark-service-affecting',
            'alarm/escalate/*',
            'alarm/escalate/critical',
            'alarm/escalate/major',
            'alarm/escalate/minor',
        ],
        functionsThatCanUseResources: [
            'admin/group/edit-members',
            'object/import',
            'reports/run'
        ],
    }),

    computed: {
        alarmResourceFunction: function() {
            return this.functionsThatCanUseAlarmResources.includes(this.$props.permission.perm_function);
        },

        resourceFunction: function() {
            return this.functionsThatCanUseResources.includes(this.$props.permission.perm_function);
        },

        alarmOfficeResource: function() {
            let chunks = this.$props.permission.perm_qualifier.split('/');
            if(chunks.length >= 1) {
                return chunks[0];
            }
            return '';
        },
        alarmLocationResource: function() {
            let chunks = this.$props.permission.perm_qualifier.split('/');
            if(chunks.length >= 2) {
                return chunks[1];
            }
            return '';
        },
        alarmDescriptionResource: function() {
            let chunks = this.$props.permission.perm_qualifier.split('/');
            if(chunks.length >= 3) {
                return chunks[2];
            }
            return '';
        },
    },

    methods: {
        okClicked: function() {
            if(this.$refs.permissionEditForm.validate()) {
                this.$emit('ok');
            }
        },

        functionChange: function() {
            let func = this.$props.permission.perm_function;
            if(func == '*' || (func.trim().substr(func.trim().length - 2) == '/*')) {
                this.$props.permission.perm_qualifier = '*';
            }
            else {
                this.$props.permission.perm_qualifier = '';
            }
        }
    },

    mounted() {

    }

  
};
</script>
